import { ReactNode, useEffect } from 'react'

import { clsx } from 'clsx'
import { Link, useLocation, useOutletContext } from 'react-router'

import { ClampTooltip } from '../../ClampTooltip'
import { useScrollIntoView } from '~/portal/hooks/useScrollIntoView'
import { RootOutletContext } from '~/portal/types/portal'

export const ApiSubNavItem = ({
  parentPath,
  identifier,
  hash,
  icon,
  activeIcon,
  active = false,
  isSelected,
  setSelectedItem,
  onClick,
}: {
  parentPath: string,
  identifier: string,
  hash: string,
  icon: ReactNode,
  activeIcon?: ReactNode,
  active?: boolean,
  isSelected: boolean,
  setSelectedItem: (selectedItem: string | null) => void,
  onClick?: (e) => void,
}) => {
  const { hash: locationHash } = useLocation()

  useEffect(() => {
    if (active && hash === locationHash) {
      setSelectedItem(identifier)
    } else if (!active) {
      setSelectedItem(null)
    }
  }, [active, hash, locationHash, setSelectedItem, identifier])

  const navActiveItemRef = useScrollIntoView<HTMLAnchorElement>()

  const { closeSideNavWithoutTransition } = useOutletContext<RootOutletContext>()
  
  const onNavigate = (e) => {
    onClick?.(e)
    closeSideNavWithoutTransition?.()
  }

  const shouldShowActiveIcon = active && hash === locationHash && activeIcon

  return (
    <Link to={`${parentPath}${hash}`}
      onClick={onNavigate}
      className={clsx(
        'sp-sidenav-api-operation ml-1 flex py-1.5 pl-2 pr-8 rounded max-w-full overflow-hidden z-40',
        active && 'hover:bg-(--sp-sidenav-item-hover-bg,var(--sp-color-surface-hover))',
        isSelected ? 'sp-sidenav-api-operation--active bg-(--sp-sidenav-item-active-bg,var(--sp-color-surface-hover)) text-(--sp-color-link) font-semibold' : '',
      )}
      ref={(active && hash === locationHash) ? navActiveItemRef : null}
    >
      <span className={clsx('pl-1 pr-2 pt-[0.219rem]', isSelected ? 'text-(--sp-sidenav-icon-selected-color,var(--neutral-60)) dark:text-(--sp-sidenav-icon-selected-color,var(--neutral-40))' : 'text-(--sp-sidenav-icon-color,var(--neutral-50)) dark:text-(--sp-sidenav-icon-color,var(--neutral-40))')}>
        {shouldShowActiveIcon ? activeIcon : icon}
      </span>
      <div className="flex-1 min-w-0">
        <ClampTooltip
          text={identifier}
          className={clsx(isSelected ? 'text-(--sp-color-link) font-semibold' : '')}
        />
      </div>
    </Link>
  )
}